import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateOrganisationDemoDashboardMutationVariables = Types.Exact<{
  orgId: Types.Scalars["Int"];
  shouldShowDemoDashboard: Types.Scalars["Boolean"];
}>;

export type UpdateOrganisationDemoDashboardMutation = {
  __typename?: "mutation_root";
} & {
  update_organisations_by_pk?: Types.Maybe<
    { __typename?: "organisations" } & Pick<
      Types.Organisations,
      "id" | "demo_dashboard"
    >
  >;
};

export const UpdateOrganisationDemoDashboardDocument = gql`
  mutation UpdateOrganisationDemoDashboard(
    $orgId: Int!
    $shouldShowDemoDashboard: Boolean!
  ) {
    update_organisations_by_pk(
      pk_columns: { id: $orgId }
      _set: { demo_dashboard: $shouldShowDemoDashboard }
    ) {
      id
      demo_dashboard
    }
  }
`;

export function useUpdateOrganisationDemoDashboardMutation() {
  return Urql.useMutation<
    UpdateOrganisationDemoDashboardMutation,
    UpdateOrganisationDemoDashboardMutationVariables
  >(UpdateOrganisationDemoDashboardDocument);
}
